var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgReturn = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 32 32",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M15.304 11.85c6.84 1.195 11.987 6.4 11.987 12.64 0 1.218-.196 2.398-.564 3.516-1.512-5.523-5.92-9.792-11.423-10.946v8.124L4.709 14.59 15.304 3.994v7.856Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgReturn);
export default ForwardRef;